import * as React from "react";
import { Funding, Modernizations, ServiceItem } from "../../calcBusterTypes";
import {
  Box,
  Container,
  Grid,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import ServicesBarChart from "./ServicesBarChart";
import ModernizationPieChart from "./ModernizationPieChart";
import Services from "./Services";

const GeneralSection = (
  funding: Funding,
  modernizations: Modernizations,
  services: ServiceItem[]
) => {
  return (
    <SpaceBetween size={"l"}>
      <Container>
        <Grid
          gridDefinition={[
            { colspan: 1 },
            { colspan: 4 },
            { colspan: 2 },
            { colspan: 4 },
            { colspan: 1 },
          ]}
        >
          <Box />
          {ServicesBarChart(services)}
          <></>
          {ModernizationPieChart(modernizations, funding)}
          <Box />
        </Grid>
      </Container>
      <Services services={services} />
    </SpaceBetween>
  );
};

export default GeneralSection;
